var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{class:_vm.modalClass,attrs:{"name":_vm.modalName,"clickToClose":false},on:{"before-open":_vm.beforeOpen,"opened":_vm.opened,"closed":_vm.closed}},[_c('a',{staticClass:"modal__close",on:{"click":_vm.closeModal}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74fa0e74","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/ModalWrapper.vue
// module id = 683
// module chunks = 5